// extracted by mini-css-extract-plugin
export default {"upload":"Data_upload__Zt13t"};